module.exports = __webpack_public_path__ + "img/courier-warp.ebbee9c9.svg";